import { Controller } from "@hotwired/stimulus"

// Toggles pricing cards between monthly and annual views.
//
// Markup:
//   <div data-controller="pricing-toggle" data-pricing-toggle-mode-value="annual">
//     <button data-action="click->pricing-toggle#monthly" data-pricing-toggle-target="monthlyBtn">…</button>
//     <button data-action="click->pricing-toggle#annual"  data-pricing-toggle-target="annualBtn">…</button>
//
//     <span data-pricing-toggle-target="monthly">$99</span>
//     <span data-pricing-toggle-target="annual"  hidden>$990</span>
//   </div>
export default class extends Controller {
  static targets = ["monthly", "annual", "monthlyBtn", "annualBtn"]
  static values = { mode: { type: String, default: "annual" } }

  connect() {
    this.apply()
  }

  monthly() { this.modeValue = "monthly"; this.apply() }
  annual()  { this.modeValue = "annual";  this.apply() }

  apply() {
    const showing = this.modeValue
    this.monthlyTargets.forEach(el => el.hidden = showing !== "monthly")
    this.annualTargets.forEach(el => el.hidden = showing !== "annual")

    if (this.hasMonthlyBtnTarget && this.hasAnnualBtnTarget) {
      this.monthlyBtnTarget.dataset.active = showing === "monthly" ? "true" : "false"
      this.annualBtnTarget.dataset.active  = showing === "annual"  ? "true" : "false"
    }
  }
}
